<template>
  <div class="modal fade" id="StoreModal" tabindex="-1" style="z-index:2040;" aria-labelledby="StoreModal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-middle">
          <div>店家名稱：{{Shop.Name}}</div>
          <div>營業時間：{{Shop.openingTime.substring(0, 5)}} ~ {{Shop.closingTime.substring(0, 5)}}</div>
          <div>店家地址：{{Shop.County + Shop.District + Shop.Address}}</div>
          <div @click="call(Shop.Phone)">聯絡方式：<span class="blue-underline">{{Shop.Phone}}</span></div>
          <div v-if="Shop.Statement">店家聲明：<span class="Statement" v-html="Shop.Statement"></span></div>
        </div>
        <div class="modal-footer">
          <div class="Left">
            <button class="btn btn-dark" data-bs-dismiss="modal">關閉</button>
          </div>
          <div class="Right" v-if="false" v-show="Global.isGuest == false && Global.isGuest != null">
            <button class="btn btn-primary" @click="GroupbuyTip()">揪團</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Global } from '@/Service/GlobalService'
import { Groupbuy } from '@/mixins/Groupbuy'
export default {
  name: "Store",
  mixins: [Groupbuy],
  data() {
    return {
      Global: Global,
    }
  },
  props: {
    Shop: Object,
  },
  methods: {
    call: function(phone) {
      window.location.href = "tel://" + phone
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  > .modal-dialog {
    > .modal-content {
      > .modal-middle {
        padding: 20px;
        font-size: 18px;
        font-weight: bold;
        > div {
          margin-bottom: 10px;
          .Statement {
            padding-top: 5px;
            padding-left: 20px;
            display: block;
            font-size: 16px
          }
        }
        .blue-underline {
          color: #5599FF;
          text-decoration: underline;
          text-decoration-color: #5599FF;
          text-underline-offset: 5px;
        }
      }
      > .modal-footer {
        display: block;
        > .Left {
          float: left;
          > button {
            font-weight: bold;
          }
        }
        > .Right {
          float: right;
          > button {
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>